<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
              $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ $t("facturasEmitidas") }}</template>
      </breadcrumb>

      <CabeceraInformes :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="idTpv" :listTpv="listTpv"
        :dateto="dateto" :datefrom="datefrom" id="cabecera" :conTodos="true" />

      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta">
        <template v-if="dateInform.length > 0">
          <div class="row justify-content-between div-export">
            <div class="col-md-12  text-left">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong>
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong>
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="table-responsive" style="overflow: auto">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span v-if="ordenarDocNumber" @click="sortedArrayASC(1), (ordenarDocNumber = 0)"><i
                        style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("factura") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(1), (ordenarDocNumber = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("factura") }}
                    </span>
                  </th>
                  <th>
                    <span v-if="ordenarAccount" @click="sortedArrayASC(2), (ordenarAccount = 0)"><i style="color: white"
                        class="fa fa-angle-up"></i>
                      {{ $t("mesa") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(2), (ordenarAccount = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("mesa") }}
                    </span>
                  </th>
                  <th>
                    <span v-if="ordenarDate" @click="sortedArrayASC(3), (ordenarDate = 0)"><i style="color: white"
                        class="fa fa-angle-up"></i>
                      {{ $t("fecha") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(3), (ordenarDate = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("fecha") }}
                    </span>
                  </th>
                  <th>
                    <span v-if="ordenarpaidType" @click="sortedArrayASC(4), (ordenarpaidType = 0)"><i
                        style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("cobro") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(4), (ordenarpaidType = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("cobro") }}
                    </span>
                  </th>
                  <th>
                    <span v-if="ordenarCifNif" @click="sortedArrayASC(5), (ordenarCifNif = 0)"><i style="color: white"
                        class="fa fa-angle-up"></i>
                      {{ $t("cifnif") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(5), (ordenarCifNif = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("cifnif") }}
                    </span>
                  </th>
                  <th>
                    <span v-if="ordenarNameClient" @click="sortedArrayASC(6), (ordenarNameClient = 0)"><i
                        style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("cliente") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(6), (ordenarNameClient = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("cliente") }}
                    </span>
                  </th>
                  <th>
                    <span v-if="ordenarAmount" @click="sortedArrayASC(7), (ordenarAmount = 0)"><i style="color: white"
                        class="fa fa-angle-up"></i>
                      {{ $t("importe") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(7), (ordenarAmount = 1)"><i style="color: white"
                        class="fa fa-angle-down"></i>
                      {{ $t("importe") }}
                    </span>
                  </th>
                  <th>{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in dateInform">
                  <td>
                    {{ obj.docNumber }}
                    <template v-if="obj.refDocNumber !== ''"><i v-tooltip.top-center="obj.refDocNumber"
                        class="fas fa-info-circle text-danger"></i></template>
                  </td>
                  <td>{{ obj.account }}</td>
                  <td>{{ obj.date | parseDate }}</td>
                  <td v-if="obj.paidType === 'E'">{{ $t("efectivo") }}</td>
                  <td v-else-if="obj.paidType === 'T'">{{ $t("tarjeta") }}</td>
                  <td v-else-if="obj.paidType === 'C'">{{ $t("cheque") }}</td>
                  <td v-else-if="obj.paidType === 'A'">{{ $t("avanzado") }}</td>
                  <td v-else-if="obj.paidType === 'PS'">{{ $t("Pago saldo") }}</td>
                  <td>{{ obj.cifnif }}</td>
                  <td>{{ obj.nameClient }}</td>
                  <td align="right">{{ obj.amount | currency }}</td>
                  <td align="center">
                    <div class="btn btn-primary btn-link text-success">
                      <a :href="urlExportTicketExcel(obj.idHeader, obj.idTpv)">
                        <i v-tooltip.top-center="$i18n.t('exportarExcel')"
                          class="fa fa-file-excel text-success"></i></a>
                    </div>

                    <!--                                    <div class="btn btn-primary btn-link text-danger">-->

                    <!--                                        <a :href="urlExportTicketPDF(obj.idHeader)">-->
                    <!--                                            <i v-tooltip.top-center="$i18n.t('exportarPdf')"-->
                    <!--                                               class="fa fa-file-pdf text-danger"></i>-->
                    <!--                                        </a>-->
                    <!--                                    </div>-->

                    <div class="btn btn-primary btn-link text-danger">
                      <a :href="urlExportTicketPDFReal(obj.idHeader, obj.idTpv)">
                        <i v-tooltip.top-center="$i18n.t('exportarPdf')" class="fa fa-file-pdf text-danger"></i>
                      </a>
                    </div>
                    <!--<div class="btn btn-primary btn-link text-danger">
                      <a
                        :href="urlExportTicketFacturaE(obj.idHeader, obj.idTpv)"
                      >
                      <i  class="bi bi-filetype-xml"></i>
                      
                    </div>-->
                    <div class="btn btn-primary btn-link text-danger" v-if="obj.amount > 0">
                      <a :href="urlExportTicketFacturaE(obj.idHeader, obj.idTpv)">
                        <svg xmlns="http://www.w3.org/2000/svg"
                          v-tooltip.top-center="'Exportar factura electrónica como XML'" width="14" height="14"
                          style="margin-bottom: 5px" fill="currentColor" class="bi bi-filetype-xml" viewBox="0 0 16 16">
                          <path fill-rule="evenodd"
                            d="M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.527 11.85h-.893l-.823 1.439h-.036L.943 11.85H.012l1.227 1.983L0 15.85h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992 1.274-2.007Zm.954 3.999v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596h-.025L4.58 11.85h-.806v3.999h.706Zm4.71-.674h1.696v.674H8.4V11.85h.791v3.325Z" />
                        </svg>
                      </a>
                    </div>
                    <div v-if="obj.dateEmailSent == 0" class="btn btn-primary btn-link text-danger"
                      @click="agregarListaCorreo(obj); openModalEnviarCorreo()">
                      <i class="fa fa-envelope btn-link text-danger"
                        v-tooltip.top-center="$i18n.t('enviarFacturaECorreo')">
                      </i>
                    </div>
                    <div v-else class="btn btn-primary btn-link text-success"
                      @click="agregarListaCorreo(obj); openModalEnviarCorreo()">
                      <i class="fa fa-envelope text-success" v-tooltip.top-center="$i18n.t('enviarFacturaECorreo')">
                      </i>
                    </div>

                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td colspan="6" class="table-success">
                    <strong>{{ $t("total") }}:</strong>
                  </td>
                  <td class="text-right">
                    <strong>
                      {{ getTotalVentas | currency }}
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayFacturasEmitidasEnEsteRangoDeFecha") }}
          </div>
        </template>
      </div>
    </div>
    <modal name="modal-enviar-correo" :adaptive=true :scrollable=true height="auto" :clickToClose=false>

      <div>
        <div class="modal-header">
          <h3 style="margin: 0px"></h3>
        </div>
        <div class="modal-body">
          <div v-for="l in listEnviarCorreo" v-if="l.dateEmailSent != 0" class="alert-success" style="padding: 15px; margin-bottom: 10px;">
            <strong>El último correo fue enviado {{ l.dateEmailSent | timeago }}</strong>
          </div>
          <table class="table table-bordered table-striped">
            <thead class="thead-dark">
              <tr>
                <th>{{ $t("factura") }}</th>
                <th>{{ $t("mesa") }}</th>
                <th>{{ $t("fecha") }}</th>
                <th>{{ $t("cobro") }}</th>
                <th>{{ $t("cifnif") }}</th>
                <th>{{ $t("cliente") }}</th>
                <th>{{ $t("importe") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="d in listEnviarCorreo">
                <td>
                  {{ d.docNumber }}
                  <template v-if="d.refDocNumber !== ''"><i v-tooltip.top-center="d.refDocNumber"
                      class="fas fa-info-circle text-danger"></i></template>
                </td>
                <td>{{ d.account }}</td>
                <td>{{ d.date | parseDate }}</td>
                <td v-if="d.paidType === 'E'">{{ $t("efectivo") }}</td>
                <td v-else-if="d.paidType === 'T'">{{ $t("tarjeta") }}</td>
                <td v-else-if="d.paidType === 'C'">{{ $t("cheque") }}</td>
                <td v-else-if="d.paidType === 'A'">{{ $t("avanzado") }}</td>
                <td v-else-if="d.paidType === 'PS'">{{ $t("Pago saldo") }}</td>
                <td>{{ d.cifnif }}</td>
                <td>{{ d.nameClient }}</td>
                <td align="right">{{ d.amount | currency }}</td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>

          <div class="form-group">
            <label><strong>Enviar factura a:</strong></label>
            <input v-model="emailClient" class="form-control" type="text" />
          </div>
          <div class="row">
            <div class="col-md-6">
              <label><strong>{{ $t("formato") }}</strong></label>
              <div class="form-group">
                <el-radio v-model="tipo" label=1>{{ $t("PDF") }}

                </el-radio>
                <el-radio v-model="tipo" label=2>{{ $t("excel") }}
                </el-radio>
                <el-radio v-model="tipo" label=3>FacturaE
                </el-radio>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal()" class="btn btn-default"><i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <!-- @click="enviarEmail(listEnviarCorreo[0].idHeader)"-->
          <button @click="enviarEmail(listEnviarCorreo[0].idHeader)" class="btn btn-primary"><i
              class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  Loading,
  DropdownItem,
  DropdownMenu,
  Button,
  Radio,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Datetime from "vue-datetime";
import { mapState } from 'vuex';

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("facturasNominativas"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Datetime]: Datetime,
    [Option.name]: Option,
    [Radio.name]: Radio,
    Breadcrumb,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      listBusinesses: [],
      idBusiness: 0,
      idTpv: 0,
      data: [""],
      listTpv: [],
      cuentasAparcadas: false,
      dateInform: ["-"],
      indice: 0,
      listEnviarCorreo: [],

      //ORDEN
      ordenarDocNumber: 0,
      ordenarAccount: 0,
      ordenarDate: 0,
      ordenarpaidType: 0,
      ordenarCifNif: 0,
      ordenarNameClient: 0,
      ordenarAmount: 0,

      respuesta: true,
      tipo: 0,
      emailClient: "",

    };
  },
  computed: {
    ...mapState(["permiso"]),
    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidas/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidas/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    getTotalVentas() {
      let xtotal = 0;

      this.dateInform.forEach(function (x) {
        xtotal += x.amount;
      });

      return xtotal;
    },
  },
  methods: {
    sortedArrayASC: function (nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarDocNumber = 1;

          function compareDocNumber(a, b) {
            if (a.docNumber.toUpperCase() < b.docNumber.toUpperCase())
              return -1;
            if (a.docNumber.toUpperCase() > b.docNumber.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDocNumber);

        case 2:
          this.ordenarAccount = 1;

          function compareAccount(a, b) {
            if (a.account < b.account) return -1;
            if (a.account > b.account) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAccount);

        case 3:
          this.ordenarDate = 1;

          function compareDate(a, b) {
            if (a.date < b.date) return -1;
            if (a.date > b.date) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDate);

        case 4:
          this.ordenarpaidType = 1;

          function comparePaidType(a, b) {
            if (a.paidType < b.paidType) return -1;
            if (a.paidType > b.paidType) return 1;
            return 0;
          }

          return this.dateInform.sort(comparePaidType);

        case 5:
          this.ordenarCifNif = 1;

          function compareCifNif(a, b) {
            if (a.cifnif.toUpperCase() < b.cifnif.toUpperCase()) return -1;
            if (a.cifnif.toUpperCase() > b.cifnif.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareCifNif);

        case 6:
          this.ordenarNameClient = 1;

          function compareNameClient(a, b) {
            if (a.nameClient.toUpperCase() < b.nameClient.toUpperCase())
              return -1;
            if (a.nameClient.toUpperCase() > b.nameClient.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareNameClient);

        case 7:
          this.ordenarAmount = 1;

          function compareAmount(a, b) {
            if (a.amount < b.amount) return -1;
            if (a.amount > b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAmount);
      }
    },
    sortedArrayDESC: function (nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarDocNumber = 0;

          function compareDocNumber(a, b) {
            if (a.docNumber.toUpperCase() > b.docNumber.toUpperCase())
              return -1;
            if (a.docNumber.toUpperCase() < b.docNumber.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDocNumber);

        case 2:
          this.ordenarAccount = 0;

          function compareAccount(a, b) {
            if (a.account > b.account) return -1;
            if (a.account < b.account) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAccount);

        case 3:
          this.ordenarDate = 0;

          function compareDate(a, b) {
            if (a.date > b.date) return -1;
            if (a.date < b.date) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDate);

        case 4:
          this.ordenarpaidType = 0;

          function comparePaidType(a, b) {
            if (a.paidType > b.paidType) return -1;
            if (a.paidType < b.paidType) return 1;
            return 0;
          }

          return this.dateInform.sort(comparePaidType);

        case 5:
          this.ordenarCifNif = 0;

          function compareCifNif(a, b) {
            if (a.cifnif.toUpperCase() > b.cifnif.toUpperCase()) return -1;
            if (a.cifnif.toUpperCase() < b.cifnif.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareCifNif);

        case 6:
          this.ordenarNameClient = 0;

          function compareNameClient(a, b) {
            if (a.nameClient.toUpperCase() > b.nameClient.toUpperCase())
              return -1;
            if (a.nameClient.toUpperCase() < b.nameClient.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareNameClient);

        case 7:
          this.ordenarAmount = 0;

          function compareAmount(a, b) {
            if (a.amount > b.amount) return -1;
            if (a.amount < b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAmount);
      }
    },
    openModalEnviarCorreo() {
      this.$modal.show("modal-enviar-correo");
    },
    closeModal() {
      this.list.forEach(function (obj) {
        obj.enviarCorreo = false;
      });
      this.listBusinessesemail = [];
      this.listEnviarCorreo = [];
      this.emailClient = "";
      this.tipo = 0;
      this.$modal.hide("modal-enviar-correo");
    },

    agregarListaCorreo(obj) {
      //this.listBusinessesemail.push(this.idBusiness);
      // console.log(this.listBusinessesemail)
      obj.enviarCorreo = true;
      this.listEnviarCorreo.push(obj);
    },


    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.cambioTpv(-1, false);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.cambioTpv()
    },
    emitirConsulta() {
      this.getFacturasEmitida();
    },
    cambioTpv(idTpvData, filtrar) {
      this.idTpv = idTpvData;
      this.emitirConsulta();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.idTpv = vm.listTpv[0].id;
              vm.getFacturasEmitida();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },

    getFacturasEmitida() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          this.loading = Loading.service({ text: "Cargando..." });

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: this.idTpv,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "sales/getFacturasEmitidas",
              config
            )
            .then(function (response) {
              if (response.data.response) {
                var dateInFromAntes = vm.dateInform;
                vm.dateInform = response.data.result;

                vm.respuesta = true;
              } else if (response.data.response == false && response.data.rangoMayor == true) {
                swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                });
                vm.respuesta = false;
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    urlExportTicketPDF(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidasById/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketPDFReal(idHeader, idTpv) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidaById/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&idTpv=" +
        idTpv +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketExcel(idHeader, idTpv) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidaById/Excel?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&idTpv=" +
        idTpv +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketFacturaE(idHeader, idTpv) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturaEById/Excel?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&idTpv=" +
        idTpv +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    enviarEmail(idHeader) {
      // console.log(this.emailClient);
      // console.log(this.tipo);
      if (this.emailClient !== "" && this.tipo != 0) {

        var config = {
          params: {
            idHeader: idHeader,
            emailCliente: this.emailClient,
            idBusiness: this.idBusiness,
            idTpv: this.idTpv,
            jwt: this.$store.getters.jwt,
            tipo: this.tipo
          },
          headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        };

        let vm = this;
        this.axios.get(this.$store.getters.apiUrl + "sales/sendEmailFactura", config)
          .then(function (response) {
            if (response.data == "OK") {

              vm.closeModal();
              vm.$notify({
                message: vm.$t("correoEnviadoCorrectamente"),
                icon: 'nc-icon nc-check-2',
                timeout: 2000,
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'success',
              });
              vm.getFacturasEmitida();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data,
                confirmButtonClass: 'btn btn-info btn-fill',
                type: 'error'
              });
            }
            vm.emailClient = "";
            vm.tipo = 0;
          }).catch(function (error) {
            console.log(error);
          });
      } else {
        swal({
          title: this.$i18n.t("atencion"),
          text: this.$i18n.t("debeIntroducirUnEmailParaEnviarElPedido"),
          confirmButtonClass: 'btn btn-info btn-fill',
          type: 'error'
        });
      }
      //  this.$modal.hide("modal-enviar-correo");
    }
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/FacturasEmitidas.vue